import service from '@/services/questions';

export default {
  loadQuestions: ({ commit, state }, product) => {
    commit('setQuestionsLoading', true);
    if (product && product.id) {
      service
        .getProductQuestions(product.id, state.questions.pagination)
        .then(response => commit('loadQuestionsSuccess', response))
        //eslint-disable-next-line no-console
        .catch(err => console.error(err));
    } else {
      service
        .getQuestions(state.questions.pagination)
        .then(response => commit('loadQuestionsSuccess', response))
        //eslint-disable-next-line no-console
        .catch(err => console.error(err));
    }
  },
  togglePublishQuestion: ({ dispatch, state, commit }, question) => {
    const payload = {
      id: question.id,
      questionText: question.questionText,
      answerText: question.answerText,
      posted: !question.posted,
    };
    commit('setQuestionForm', payload);
    service
      .updateQuestion(state.questionForm)
      .then(() => dispatch('loadQuestions', { id: question.productId }))
      //eslint-disable-next-line no-console
      .catch(err => console.error(err));
  },
  sendQuestionForm: ({ dispatch, state, commit }, product) => {
    let result = null;
    if (state.questionForm.posted == null) {
      state.questionForm.posted = false;
    }
    if (!state.questionForm.id) {
      result = service.createQuestion(product.id, state.questionForm);
      commit('setQuestionsAnswered');
    } else if (state.questionForm.answered) {
      result = service.updateQuestion(state.questionForm);
    } else {
      result = service.createAnswer(state.questionForm);
    }
    result.then(() => {
      dispatch('loadQuestions', product);
    });
  },
  deleteQuestion: ({ dispatch }, data) => {
    const result = service.deleteQuestion(data.question_id);

    result.then(() => {
      dispatch('loadQuestions', data.product);
    });
  },
  setQuestionsPagination({ commit }, payload) {
    commit('setQuestionsPagination', payload);
  },
  setQuestionForm({ commit }, payload) {
    commit('setQuestionForm', payload);
  },
  resetQuestionForm({ commit }) {
    commit('setQuestionForm', {
      show: false,
      valid: false,
      id: null,
      userName: null,
      userEmail: null,
      timestamp: null,
      questionText: null,
      answerText: null,
      posted: false,
    });
  },
};
